module.exports = __webpack_public_path__ + "img/unified-empty.d7ca7e7e.svg";